// Shared environment utilities to avoid circular dependencies

export enum SupportedEnvironments {
  Dev = 'development',
  Prod = 'production'
}

export function CheckEnvironment(supportedEnv: SupportedEnvironments) {
  return process.env.REACT_APP_ENV === supportedEnv;
}

export function CheckLocalDev() {
  //NOTE: The .env file will produce a string if you give it a boolean.
  return (
    process.env.REACT_APP_LOCAL_DEV === 'true' &&
    process.env.REACT_APP_ENV === SupportedEnvironments.Dev
  );
}
